// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".christmas-destocking-banner .title h2{margin-bottom:0;font-weight:400;font-size:24px;font-size:1.5rem}@media(min-width:768px){.christmas-destocking-banner .title h2{font-size:32px;font-size:2rem}}.christmas-destocking-banner .subtitle{font-size:18px;font-size:1.125rem}@media(min-width:768px){.christmas-destocking-banner .subtitle{font-size:22px;font-size:1.375rem}}", ""]);
// Exports
module.exports = exports;
